function Header() {
    return (
        <div className="header">
            <h1>Skin Generator for Serum VST*</h1>
            <h4>alpha version X.0.4 / public preview</h4>
        </div>
    )
}

export default Header;